(ns ycweb.app.website.products.components.hunt
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc hunt-modal-header < rum/reactive [app-atom config-atom]
  (let [header-public-id (cmn/curact config-atom [:config :header-public-id])]
    (when (u/presence header-public-id)
      (web-common/lazy-image app-atom
        header-public-id
        {:class (u/bem :yc-simple-image [:full :s-margin] :hunt-pop-graphic)}
        {:q "auto"
         :alt ""}))))

(rum/defc hunt-modal-body < rum/reactive [app-atom config-atom _]
  (let [{:keys [state message already-found?]} (cmn/curact config-atom [:config])
        newsletter-atom (rum/cursor-in config-atom [:config :newsletter])
        promotions-atom (rum/cursor-in config-atom [:config :promotions])]
    [:div
     (hunt-modal-header app-atom config-atom)
     (case state
       :checking
       [:div.u-text-center.u-padding-20
        [:div.loading-spinner]]

       :loading
       [:div.u-text-center.u-padding-20
        [:p.yc-paragraph "Submitting your entry…"]
        [:div.loading-spinner]]

       :success
       [:div.u-text-center
        [:p.yc-paragraph
         (str "Thank you, we have " (when already-found? "already ") "received your entry. Good luck.")]
        (buttons/button-web "Close"
          {:style :secondary
           :on-click #(grid/close-modal app-atom)})]

       [:div
        (headings/heading "You found the hidden icon!"
          {:type :h2
           :size :small
           :center true})
        (when message
          [:div.u-margin-bottom-16
           (feedback/feedback :error message)])
        [:div.u-max-width-320.u-block-center
         [:p.yc-paragraph.u-text-center
          "Enter your name and email address below to stand a chance to win today's prize."]
         [:div.form-field
          (forms/split-input-field
            ["First name:" "e.g. Jane" (rum/cursor-in config-atom [:config :firstname])
             {:required? true :id "firstname"}]
            ["Last name:" "e.g. Smith" (rum/cursor-in config-atom [:config :lastname])
             {:required? true :id "lastname"}])]
         (forms/input "Email:" "e.g. jane@domain.com"
           (rum/cursor-in config-atom [:config :email])
           {:required? true :type :email :id "email"})
         [:div.form-field
          (forms/toggle "Newsletters and personalised offers"
            newsletter-atom
            {:id "newsletter"
             :description "Find out first about new launches and deals, plus the chance to receive occasional vouchers"
             :on-change
             (fn [_]
               (let [new-val (not @newsletter-atom)]
                 (reset! newsletter-atom new-val)
                 (when new-val
                   (reset! promotions-atom true))))})]
         [:div.form-field
          (forms/toggle "Personalised offers only"
            promotions-atom
            {:id "promotion"
             :disabled (cmn/curact config-atom [:config :newsletter])
             :description "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"})]]])]))

(rum/defc hunt-modal-footer < rum/reactive [app-atom config-atom _]
  (let [state (cmn/curact config-atom [:config :state])
        captcha-site-key (get-in @app-atom [:config :captcha-site-key])]
    (when (= state :form)
      (grid/button-row
        {:single-text "Submit"
         :single-style :primary
         :single-fn
         (fn []
           (if captcha-site-key
             (appcommon/recaptcha app-atom captcha-site-key
               :web.product/hunt-register
               (:config @config-atom))
             (grid/dispatch-action app-atom
               :web.product/hunt-register
               (:config @config-atom))))}))))

(defmethod grid/modal-config :web.product/hunt-modal [_ _ _]
  {:body hunt-modal-body
   :footer hunt-modal-footer
   :modal-type :variable
   :max-width "480"})

(defn- open-hunt-modal [app-atom {:keys [content_id header_public_id]}]
  (let [user (get-in @app-atom [:user])]
    (grid/open-modal app-atom :web.product/hunt-modal
      {:config
       {:firstname (or (:firstname user) "")
        :lastname (or (:lastname user) "")
        :email (or (:email user) "")
        :newsletter false
        :promotions false
        :state :checking
        :contentid content_id
        :header-public-id header_public_id}})
    (comms/ajax-call :post :web.product/hunt-status
      {:contentid content_id}
      app-atom
      {:manual-error-handler? true})))

;; Swaps the modal atom directly - update-modal-config skips a modal that is
;; still in its 25ms open animation, which would leave it stuck checking.
;; A failed check falls through to the form.
(defmethod comms/receive :web.product/hunt-status [app-atom {:keys [already-found?]}]
  (let [modal-atom (grid/modal-cursor app-atom)
        {modal-type :type config :config} @modal-atom]
    (when (and
            (= modal-type :web.product/hunt-modal)
            (= :checking (get-in config [:config :state])))
      (swap! modal-atom update-in [:config :config] assoc
        :state (if already-found? :success :form)
        :already-found? (boolean already-found?)))))

(defmethod grid/action :web.product/hunt-register [app-atom config _]
  (let [{:keys [contentid firstname lastname email newsletter promotions captcha-token]} config]
    (grid/update-modal-config app-atom :web.product/hunt-modal
      {:config (assoc config :state :loading :message nil)})
    (comms/ajax-call :post :web.product/hunt-register
      {:captcha-token captcha-token
       :contentid contentid
       :firstname firstname
       :lastname lastname
       :email email
       :newsletter (boolean newsletter)
       :promotions (boolean promotions)}
      app-atom
      {:manual-error-handler? true})))

(defmethod comms/receive :web.product/hunt-register [app-atom e]
  (let [modal-atom (grid/modal-cursor app-atom)
        current-config (get-in @modal-atom [:config :config])]
    (grid/update-modal-config app-atom :web.product/hunt-modal
      {:config
       (if (:entered? e)
         (assoc current-config
           :state :success
           :already-found? (:already-found? e))
         (assoc current-config
           :state :form
           :message (or (:message e) (:msg e) "Please try again later.")))})))

(rum/defc page-hunt < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [id mobile_public_id] :as hunt} (:hunt (cmn/curact process-atom :product))]
    (when id
      [:div.spa-hunt-graphic
       [:a.spa-hunt-graphic__link.flex-grid-group.flex-grid-group--inline.flex-grid-group--align-left.flex-grid-group--valign-middle
        (urlstate/href-on-click #(open-hunt-modal app-atom hunt))
        [:div.flex-grid-block.flex-grid-block--fluid.flex-grid-block--shrink-0.flex-grid-block--ml-order-02
         [:div.spa-hunt-graphic__icon.flex-grid-content
          (when (u/presence mobile_public_id)
            [:img.yc-simple-image.yc-simple-image--full
             {:src (str "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/" mobile_public_id)
              :alt "Hunt competition graphic"}])]]
        [:div.flex-grid-block.flex-grid-block--fluid.flex-grid-block--ml-order-01
         [:div.flex-grid-content
          [:span.button.button--default.button--raised.button--primary.button--inherit-hover
           [:span.button__text "You found it!"]]]]]])))
